<template>
  <GuSearchForm
    v-model="quickFilterValue"
    placeholder="Quick Filter"
    size="sm"
    class="grid-quick-filter"
    @keydown.enter.prevent
  />
</template>

<script setup>
import { inject, watch, nextTick } from 'vue'
import { _debounce } from '@shared/libs/lodash'
import { GuSearchForm } from '@shared/gu-components/search-form'
import { injectRowModelType } from '@gu-datagrid-new/composables/RowModelType'

const props = defineProps({
  gridApi: {
    type: Object,
    required: true,
  },
})

const gridState = inject('gridState')
const rowModelType = injectRowModelType()

if (!gridState) {
  console.error('[Datagrid] QuickFilter: gridState injection failed')
  throw new Error('gridState injection failed')
}
if (!rowModelType) {
  console.error('[Datagrid] QuickFilter: rowModelType injection failed')
  throw new Error('rowModelType injection failed')
}

const quickFilterValue = gridState.quickFilterValue

const updateQuickFilter = _debounce((newValue) => {
  if (props.gridApi && gridState) {
    gridState.setQuickFilter(props.gridApi, newValue, rowModelType.value)
  } else {
    console.warn('[Datagrid] QuickFilter: gridApi or gridState not available')
  }
}, 500, { maxWait: 1000 })

watch(
  quickFilterValue,
  async (newValue, oldValue) => {
    if (newValue !== oldValue) {
      await nextTick()
      updateQuickFilter(newValue)
    }
  },
)
</script>

<style lang="scss">
.grid-quick-filter .form-control-sm {
  // make the quick filter the same height as all other buttons
  height: 2rem;
}
</style>
